import { useRef } from "react";
import { Icons } from "../../_assets/icons/Icons";
import "./styles.scss";

type CustomSearchBarProps = {
    disabled?: boolean;
    onChange?: (value) => void;
    placeholder?: string;
    className?: string;
    style?: React.CSSProperties;
    dynamicPlacerHolder?: string;
    type?: "text" | "number";
    value?: string;
};

export function CustomSearchBar({
    disabled = false,
    onChange = () => {},
    placeholder,
    className = '',
    style,
    value,
    type = "text",
}: CustomSearchBarProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const setFocus = () => {
        inputRef.current && inputRef.current?.focus();
    };
    const clearValue = () => {
        onChange({ target: { value: "" } });
        setFocus();
    };
    const hasValue = value != null && value !== "";
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== "Escape") return;
        if (hasValue) {
            clearValue();
        } else {
            inputRef.current?.blur();
        }
    };

    return (
        <div className={`${className} search-box`}>
            <input
                ref={inputRef}
                type={type}
                style={style}
                value={value}
                className={`input-search`}
                placeholder={placeholder}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                autoFocus
                // Not `off`: Chrome ignores it for fields its heuristics read
                // as an email/name — and the invitations placeholder starts
                // with "Email", so picking a suggestion in the "new invitation"
                // dialog also filled THIS box (there is no <form>, so Chrome
                // groups every input on the page) and silently filtered the
                // list. `new-password` is the value Chrome does honour.
                autoComplete='new-password'
                name='search'
            />
            {hasValue ? (
                <button
                    type="button"
                    className="search-button search-button--clear"
                    onClick={clearValue}
                    aria-label="clear"
                >
                    <img className="c-img-1rem" src={Icons.close} alt="clear" />
                </button>
            ) : (
                <button
                    type="button"
                    className="search-button"
                    onClick={() => setFocus()}
                    tabIndex={-1}
                >
                    <img className="c-img-1rem" src={Icons.search} alt="search" />
                </button>
            )}
        </div>
    );
}
